import adminAPI from '@/api/adminAPI';

const requireAdminAccess = async (to, from, next) => {
  try {
    await adminAPI.getAdminHome();
    next();
  } catch (error) {
    console.error(error);
    next({ name: 'notallowed' });
  }
};

export default [
  {
    path: '/admin/home',
    name: 'adminHome',
    component: () => import('@/views/admin/adminHomePage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
  {
    path: '/admin/companylist',
    name: 'companyList',
    component: () => import('@/views/admin/companyListPage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
  {
    path: '/admin/super-user',
    name: 'adminSuperUser',
    component: () => import('@/views/admin/superUserPage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
  {
    path: '/admin/announcements',
    name: 'adminAnnouncementList',
    component: () => import('@/views/admin/announcementListPage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
  // 고정 경로인 /new가 announcementId로 해석되지 않도록 동적 상세 라우트보다 먼저 선언한다.
  {
    path: '/admin/announcements/new',
    name: 'adminAnnouncementCreate',
    component: () => import('@/views/admin/announcementPage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
  {
    path: '/admin/announcements/:announcementId',
    name: 'adminAnnouncementDetail',
    component: () => import('@/views/admin/announcementPage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
  {
    path: '/admin/companydetail/:companyId',
    name: 'adminCompanyDetail',
    component: () => import('@/views/admin/companyDetailPage.vue'),
    meta: {
      auth: true,
      accountAllowedMenu: false,
    },
    beforeEnter: requireAdminAccess,
  },
];
